import { useEffect, useRef, useState } from "react";
import { Plus, Save } from "react-feather";
import { useDispatch } from "react-redux";
import { toast } from "react-toastify";
import {
  getDropdownData,
  getOtherRefDetails,
  getOtherRefSearchDropdown,
  getTextByValueAndKey,
} from "../../api/keyvalue";
import { AUTH_TYPES, FORMS, MODULES } from "../../const";
import { formatFromJsonDate, isAfterJson } from "../../dateConfig";
import { isNumber } from "../../helper";
import useDynamicValidation from "../../hooks/useDynamicValidation";
import { requestActions } from "../../store/request-slice";
import { mobilePhoneMenValidator } from "../../validators";
import Grid from "../Grid";
import Button from "../input/Button";
import Dropdown from "../input/Dropdown";
import Input from "../input/Input";
import SearchDropdown from "../input/SearchDropdown";
import ButtonRenderer from "../renderer/ButtonRenderer";
import { ResizableScrollingTextRenderer } from "../renderer/StyleRenderer";
import {
  locationValidation,
  validateRequestLocation,
} from "../validations/validateRequestCreation";
import { useSelector } from "react-redux";
import LoadingSpinner from "../LoadingSpinner";

const AddViaLocations = ({
  getPreviousLocation,
  requestStartLocation,
  requestEndLocation,
  items,
  setItems,
  isLocationOrderInvalid,
  seq,
  setSeq,
  count,
  setCount,
  locationCustomerId,
  editMode,
  VIA_LOCATION,
  viewOnlyMode,
  closePopUp,
  dropdown,
}) => {
  const dispatch = useDispatch();
  // const FORM = FORMS.REQUEST.LOCATION.form;
  const [isAddLoading, setIsAddLoading] = useState(false);
  const [errors, setErrors] = useState({});
  const [viaSearchFieldReset, setViaSearchFieldReset] = useState(false);
  const viaLocationRef = useRef();
  const [gridData, setGridData] = useState([]);
  const [isSavingLocation, setIsSavingLocation] = useState(false);
  const auth = useSelector(
    (state) => state.user.permissions[MODULES.Transaction]
  );
  const FORM = FORMS?.REQUEST?.LOCATION?.form;
  const allowBulkAddViaLocations = auth?.[FORM]?.BULK_ADD?.CREATE;
  console.log("allowBulkAddViaLocationsSSS", allowBulkAddViaLocations);

  const dynamicValidationStatus = useDynamicValidation(
    locationValidation,
    VIA_LOCATION,
    true
  );

  const [isDropdownLoading, setIsDropdownLoading] = useState(false);
  const [intervalTypeOptions, setIntervalTypeOptions] = useState([]);
  const [intervalType, setIntervalType] = useState(1);
  const [selectedCustomInterval, setSelectedCustomInterval] = useState("");
  const [maxIntervalInMs, setMaxIntervalInMs] = useState(0);
  const [maxIntervalInHoursAndMinutes, setMaxIntervalInHoursAndMinutes] =
    useState("");
  const [customIntervalErrors, setCustomIntervalErrors] = useState({});
  const [rlkPickDrop, setRlkPickDrop] = useState("");
  const [rlkLocId, setRlkLocId] = useState(null);

  const getLabelData = async (locId) => {
    const locationResponse = await getOtherRefDetails({
      type: "location_customer",
      value: locationCustomerId?.toString(),
      param2: locId?.toString(),
    });
    const locationDetails =
      locationResponse && locationResponse.length > 0
        ? locationResponse[0]
        : {};

    const rlkLocationTypeValue = await getTextByValueAndKey("rlk_location", 3);

    //   const contactPersonResponse = requestViaLocation.rlkContactPersonId
    //     ? await getFieldValuesByTableAndId({
    //         tableName: "masterdata.tms_m_contacts",
    //         ids: requestViaLocation.rlkContactPersonId?.toString(),
    //         primaryKey: "con_id",
    //         fieldNames: "con_name",
    //       })
    //     : null;

    //   const rlkContactPersonValue = contactPersonResponse
    //     ? contactPersonResponse[0].field1
    //     : "";

          const rlkPickDropTypeValue = await getTextByValueAndKey(
          "pick_drop_type",
          rlkPickDrop
        );

    return { locationDetails, rlkLocationTypeValue, rlkContactPersonValue: "",rlkPickDropTypeValue };
  };

  const onLocationClick = async (locId, pickDrop) => {
    console.log("LocId", locId);
    setIsSavingLocation(true);

    let requestLocationErrors = {};

    if (!locId) {
      requestLocationErrors ={ ...requestLocationErrors, rlkLocation: "please select a location" }
      // requestLocationErrors.rlkLocation = "Please select a location";
      toast.warn("Please select a location", {
        autoClose: 10000,
        containerId: "Modal",
      });
      setErrors(requestLocationErrors);
      setIsSavingLocation(false);
      return;
    }

    if (!pickDrop) {
      requestLocationErrors = { ...requestLocationErrors, rlkPickDrop: "Pick Drop Type is required" }
      // requestLocationErrors.rlkPickDrop = "Pick Drop Type is required";
      toast.warn("Pick Drop Type is required", {
        autoClose: 10000,
        containerId: "Modal",
      });
      setErrors(requestLocationErrors);
      setIsSavingLocation(false);
      return;
    }

    if (Object.keys(requestLocationErrors).length === 0) {
      if (isLocationOrderInvalid(seq, locId)) {
        toast.warn("Invalid Location order", {
          autoClose: 10000,
          containerId: "Modal",
        });
        setIsSavingLocation(false);
        return;
      }
      const {
        locationDetails,
        rlkLocationTypeValue,
        rlkContactPersonValue,
        rlkPickDropTypeValue,
      } = await getLabelData(locId);

      setGridData((prevState) => [
        ...prevState,
        {
          rlkLocationType: 3,
          rlkLocation: locId,
          locationName: locationDetails.retField1,
          rlkAddress: locationDetails.retField2,
          rlkEmail: locationDetails.retField6,
          rlkContactNumber: locationDetails.retField5,
          rlkLon: locationDetails.retField10,
          rlkLat: locationDetails.retField9,
          rlkLocationTypeValue,
          rlkContactPersonValue,
          rlkActive: 1,
          rlkSeq: seq,
          id: count,
          rlkLocationContactNumber: "",
          rlkLocationContactName: "",
          requestConsigneesRequests: [],
          rlkLocationTimeUpdated: false,
          rlkPickDrop: pickDrop,
          rlkPickDropValue: rlkPickDropTypeValue,
        },
      ]);

      setSeq((prevState) => prevState + 1);
      setCount((prevState) => prevState + 1);

      resetFields();
      setIsSavingLocation(false);
    } else {
      setErrors(requestLocationErrors);
      document.querySelector(".ui.form").classList.add("error");
    }
    setIsSavingLocation(false);
  };

  const calcTimeInterval = (type, loadingTimeGapMs, travelTimeGapMs) => {
    switch (type) {
      case 1: {
        console.log("start location", requestStartLocation);
        console.log("end location", requestEndLocation);
        const startMs = Date.parse(requestStartLocation?.rlkDepartureEta);
        const endMs = Date.parse(requestEndLocation?.rlkArrivalEta);

        if (!Number.isFinite(startMs) || !Number.isFinite(endMs)) {
          return { ok: false, error: "Invalid start/end date(s)." };
        }
        if (endMs <= startMs) {
          return {
            ok: false,
            error: "End arrival must be after start departure.",
          };
        }
        if (!Array.isArray(gridData) || gridData.length === 0) {
          return { ok: true, data: [] };
        }
        if (!Number.isFinite(loadingTimeGapMs) || loadingTimeGapMs < 0) {
          return {
            ok: false,
            error: "Loading Time must be a non-negative number (milliseconds).",
          };
        }

        const N = gridData.length;
        const totalTimeGapMs = endMs - startMs;
        const totalLoadingTimeMs = N * loadingTimeGapMs;
        const availableTravelMs = totalTimeGapMs - totalLoadingTimeMs;

        if (availableTravelMs <= 0) {
          return {
            ok: false,
            error: `Not enough time to fit ${N} vias.. Reduce loading or extend the start departure and end arrival window.`,
          };
        }

        const travelTimeBetweenVias = Math.floor(availableTravelMs / (N + 1));
        const remainder = availableTravelMs % N;

        const copyOfGridData = [...gridData];
        copyOfGridData.sort(
          (a, b) => (Number(a.rlkSeq) || 0) - (Number(b.rlkSeq) || 0)
        );

        console.log("copy of grid data", copyOfGridData);
        let cursor = startMs; // previous departure
        let updated = [];
        let index = 0;
        for (let v of copyOfGridData) {
          const travelTimeBetweenThisAndNext =
            travelTimeBetweenVias + (index < remainder ? 1 : 0);
          const arrivalMs = cursor + travelTimeBetweenThisAndNext;
          const departureMs = arrivalMs + loadingTimeGapMs;
          cursor = departureMs;
          index++;

          if (arrivalMs >= endMs) {
            return {
              ok: false,
              error:
                "Computed last via arrival exceeds end arrival. Reduce loading or extend the start departure and end arrival window.",
            };
          }

          if (cursor >= endMs) {
            return {
              ok: false,
              error:
                "Computed last via departure exceeds end arrival. Reduce loading or extend the start departure and end arrival window.",
            };
          }

          updated.push({
            ...v,
            rlkArrivalEta: new Date(arrivalMs).toISOString(),
            rlkDepartureEta: new Date(departureMs).toISOString(),
            rlkArrivalEtaFormatted: formatFromJsonDate(arrivalMs),
            rlkDepartureEtaFormatted: formatFromJsonDate(departureMs),
          });
        }

        console.log("out", updated);
        return { ok: true, data: updated };
      }
      case 2: {
        const startMs = Date.parse(requestStartLocation?.rlkDepartureEta);
        const endMs = Date.parse(requestEndLocation?.rlkArrivalEta);

        if (!Number.isFinite(startMs) || !Number.isFinite(endMs)) {
          return { ok: false, error: "Invalid start/end date(s)." };
        }
        if (endMs <= startMs) {
          return {
            ok: false,
            error: "End arrival must be after start departure.",
          };
        }
        if (!Array.isArray(gridData) || gridData.length === 0) {
          return { ok: true, data: [] };
        }
        if (!Number.isFinite(loadingTimeGapMs) || loadingTimeGapMs < 0) {
          return {
            ok: false,
            error: "Loading Time must be a non-negative number (milliseconds).",
          };
        }

        if (!Number.isFinite(travelTimeGapMs) || travelTimeGapMs < 0) {
          return {
            ok: false,
            error: "Travel Time must be a non-negative number (milliseconds).",
          };
        }

        const copyOfGridData = [...gridData];
        copyOfGridData.sort(
          (a, b) => (Number(a.rlkSeq) || 0) - (Number(b.rlkSeq) || 0)
        );

        let cursor = startMs; // previous departure
        let updated = [];
        for (let v of copyOfGridData) {
          const arrivalMs = cursor + travelTimeGapMs;
          const departureMs = arrivalMs + loadingTimeGapMs;
          cursor = departureMs;

          if (arrivalMs >= endMs) {
            return {
              ok: false,
              error:
                "Computed last via arrival exceeds end arrival. Reduce loading/traveling time or extend the start departure and end arrival window.",
            };
          }

          if (cursor >= endMs) {
            return {
              ok: false,
              error:
                "Computed last via departure exceeds end arrival. Reduce loading/traveling time or extend the start departure and end arrival window.",
            };
          }

          updated.push({
            ...v,
            rlkArrivalEta: new Date(arrivalMs).toISOString(),
            rlkDepartureEta: new Date(departureMs).toISOString(),
            rlkArrivalEtaFormatted: formatFromJsonDate(arrivalMs),
            rlkDepartureEtaFormatted: formatFromJsonDate(departureMs),
          });
        }

        console.log("out", updated);
        return { ok: true, data: updated };
      }

      default:
        return { ok: false, error: "Unsupported type." };
    }
  };

  const onAddClick = async (item) => {
    setIsAddLoading(true);
    console.log("item", item);
    const requestLocationErrors = validateRequestLocation(
      {
        ...item,
        rlkContactPersonId: item.rlkContactPersonId || null,
        rlkLocationContactName: item.rlkLocationContactName || null,
        rlkLocationContactNumber: item.rlkLocationContactNumber || null,
      },
      dynamicValidationStatus
    );

    const prevLocation = getPreviousLocation(item.rlkSeq);

    if (Object.keys(requestLocationErrors).length === 0) {
      // Validate departure date is after arrival date
      if (isAfterJson(item.rlkArrivalEta, item.rlkDepartureEta)) {
        toast.error(
          `${item.locationName} Departure date should be after arrival date`,
          {
            autoClose: 10000,
            containerId: "Modal",
          }
        );
        setIsAddLoading(false);
        return;
      }

      // Validate arrival time after the previous location's departure time
      if (prevLocation) {
        if (!isAfterJson(item.rlkArrivalEta, prevLocation.rlkDepartureEta)) {
          toast.error(
            `${item.locationName} Arrival date should be after previous location departure date`,
            {
              autoClose: 10000,
              containerId: "Modal",
            }
          );
          setIsAddLoading(false);
          return;
        }
      }

      if (isLocationOrderInvalid(seq, item.rlkLocation)) {
        toast.warn("Invalid Location order", {
          autoClose: 10000,
          containerId: "Modal",
        });
        setIsAddLoading(false);
        return;
      }

      dispatch(
        requestActions.addLocation({
          ...item,
        })
      );
      setIsAddLoading(false);
    } else {
      Object.entries(requestLocationErrors).forEach(([key, msg]) => {
        if (!msg) return; // skip empty/null
        toast.error(`${item.locationName}: ${msg}`, {
          autoClose: 10000,
          containerId: "Modal",
        });
      });

      setItems((prev) => prev.filter((loc) => loc.rlkSeq !== item.rlkSeq)); // remove invalid location
      setIsAddLoading(false);
      return;
    }
  };

  const onAutoSchedule = () => {
    setIsAddLoading(true);
    const endMs = Date.parse(requestStartLocation?.rlkDepartureEta);
    const startMs = Date.parse(requestStartLocation?.rlkArrivalEta);
    const startLoadingGap = endMs - startMs;
    const loadingTimeMs = Math.floor(startLoadingGap);

    const res = calcTimeInterval(intervalType, loadingTimeMs);

    if (!res.ok) {
      toast.error(res.error, {
        autoClose: 10000,
        containerId: "Modal",
      });
      setIsAddLoading(false);
      return;
    } else {
      setGridData(res.data);
      console.log("res.data", res.data);
      setItems(res.data);

      res.data.forEach((item, index) => {
        onAddClick(item);
      });

      setIntervalType(1);
      closePopUp();
    }

    setIsAddLoading(false);
  };

  console.log("Items in via component", items);
  const cellEditorParams = (params) => {
    console.log("params in cell editor", params);

    switch (params.colDef.field) {
      case "rlkLocationContactName": {
        setGridData((prev) =>
          prev.map((row) => {
            if (row.id === params.data.id) {
              return {
                ...row,
                rlkLocationContactName: params.value,
              };
            }
            return row;
          })
        );

        break;
      }
      case "rlkLocationContactNumber": {
        console.log("In the rlkLocationContactNumber");

        const contactError = validateRequestLocation(
          {
            rlkLocationContactNumber: params.value,
          },
          {
            rlkLocationContactNumber: {
              validators: [mobilePhoneMenValidator()],
              name: "Contact Number",
            },
          }
        );
        if (contactError.rlkLocationContactNumber) {
          setGridData((prev) =>
            prev.map((row) => {
              if (row.id === params.data.id) {
                return {
                  ...row,
                  rlkLocationContactNumber: "",
                };
              }
              return row;
            })
          );
          toast.error(contactError.rlkLocationContactNumber, {
            autoClose: 10000,
            containerId: "Modal",
          });
          return;
        }
        setGridData((prev) =>
          prev.map((row) => {
            if (row.id === params.data.id) {
              return {
                ...row,
                rlkLocationContactNumber: params.value,
              };
            }
            return row;
          })
        );

        break;
      }

      default:
    }
  };
  console.log("gridData", gridData);

  function msToHuman(ms) {
    ms = Math.max(0, Math.floor(ms));
    const sec = Math.floor(ms / 1000) % 60;
    const min = Math.floor(ms / 60000) % 60;
    const hr = Math.floor(ms / 3600000) % 24;
    const day = Math.floor(ms / 86400000);

    const parts = [];
    if (day) parts.push(`${day}d`);
    if (hr) parts.push(`${hr}h`);
    if (min) parts.push(`${min}min`);
    if (!parts.length) parts.push(`${sec}s`);
    return parts.join(" ");
  }

  useEffect(() => {
    const startMs = Date.parse(requestStartLocation?.rlkDepartureEta);
    const endMs = Date.parse(requestEndLocation?.rlkArrivalEta);
    const availTotalTimeGap = endMs - startMs;

    const startLoadingGap =
      Date.parse(requestStartLocation?.rlkDepartureEta) -
      Date.parse(requestStartLocation?.rlkArrivalEta);
    const loadingTimeMs = Math.floor(startLoadingGap);

    const N = gridData?.length;
    const maxIntervalMs = Math.floor(
      (availTotalTimeGap - loadingTimeMs * N) / (N + 1)
    );
    setMaxIntervalInMs(maxIntervalMs);

    const maxIntervalInHumanReadable = msToHuman(maxIntervalMs);
    setMaxIntervalInHoursAndMinutes(maxIntervalInHumanReadable);
  }, [intervalType, gridData, requestStartLocation, requestEndLocation]);

  useEffect(() => {
    (async () => {
      setIsDropdownLoading(true);
      const opt = await getDropdownData("vl_interval_type");
      setIntervalTypeOptions(opt);
      setIsDropdownLoading(false);
    })();
  }, []);

  const onCustomSchedule = () => {
    setIsAddLoading(true);
    const travelTimeMs = selectedCustomInterval * 60 * 1000;

    const endMs = Date.parse(requestStartLocation?.rlkDepartureEta);
    const startMs = Date.parse(requestStartLocation?.rlkArrivalEta);
    const startLoadingGap = endMs - startMs;
    const loadingTimeMs = Math.floor(startLoadingGap);

    const res = calcTimeInterval(intervalType, loadingTimeMs, travelTimeMs);

    if (!res.ok) {
      toast.error(res.error, {
        autoClose: 10000,
        containerId: "Modal",
      });
      setIsAddLoading(false);
      return;
    } else {
      setGridData(res.data);
      console.log("res.data", res.data);
      setItems(res.data);

      res.data.forEach((item, index) => {
        onAddClick(item);
      });

      setIntervalType(1);
      setSelectedCustomInterval("");
      closePopUp();
    }

    setIsAddLoading(false);
  };

  const resetFields = () => {
    setRlkLocId(null);
    setRlkPickDrop("");
    setViaSearchFieldReset(true);
  };

  return (
    <>
      {isDropdownLoading ? (
        <LoadingSpinner />
      ) : (
        <div className="ui form segment" style={{width:"100vw"}}>
          <div className="ui segment">
            <h4 className="ui dividing header">Location Info</h4>
            <div className="two fields">
              <SearchDropdown
                readOnly={viewOnlyMode || editMode}
                useDynamicFields={true}
                disabled={
                  !requestStartLocation?.rlkArrivalEta ||
                  !requestStartLocation?.rlkDepartureEta ||
                  !requestEndLocation?.rlkArrivalEta ||
                  !requestEndLocation?.rlkDepartureEta
                }
                editMode={editMode}
                reset={viaSearchFieldReset}
                form={VIA_LOCATION}
                module={MODULES.Transaction}
                field="rlk_via_location"
                setReset={setViaSearchFieldReset}
                ref={viaLocationRef}
                api={getOtherRefSearchDropdown}
                threshold={1}
                apiDependency={{
                  type: "location_customer",
                  value: locationCustomerId?.toString(),
                }}
                clearable={true}
                onResultSelect={(data) => {
                  // onLocationClick(data);
                  setRlkLocId(data);
                }}
                required={true}
                label="Location"
                error={errors.rlkLocation}
                resetError={() =>
                  setErrors((prevState) => {
                    const { rlkLocation: _, ...rest } = prevState;
                    return rest;
                  })
                }
                // singleTwoWayBinding={true}
              />

              <Dropdown
                required={true}
                label="Pick Drop Type"
                form={VIA_LOCATION}
                module={MODULES.Transaction}
                field="rlk_pick_drop"
                options={dropdown.pickDropTypeOptions}
                value={rlkPickDrop}
                onChange={(e, data) => {
                  setRlkPickDrop(data.value);
                }}
                readOnly={viewOnlyMode || editMode}
                useDynamicFields={true}
                disabled={
                  !requestStartLocation?.rlkArrivalEta ||
                  !requestStartLocation?.rlkDepartureEta ||
                  !requestEndLocation?.rlkArrivalEta ||
                  !requestEndLocation?.rlkDepartureEta
                }
                editMode={editMode}
                error={errors.rlkPickDrop}
                resetError={() =>
                  setErrors((prevState) => {
                    const { rlkPickDrop: _, ...rest } = prevState;
                    return rest;
                  })
                }
              />
            </div>

            <div
              style={{
                display: "flex",
                alignItems: "center",
                width: "100%",
                justifyContent: "flex-end",
              }}
            >
              <Button template="reset" onClick={resetFields} />
              <Button
                // disabled={viewOnlyMode || !rlkPickDrop || !rlkLocId || editMode}
                label={"Add"}
                Icon={Plus}
                onClick={() => onLocationClick(rlkLocId, rlkPickDrop)}
                isLoading={isSavingLocation}
              />
            </div>

            <Grid
              isLoading={isSavingLocation}
              pagination={false}
              cellSizeStrategy="fitCellContents"
              fitContentCellls={["locationName"]}
              heading="Via Location List"
              stopEditingWhenCellsLoseFocus={true}
              onCellEditingStopped={cellEditorParams}
              fullRowEdit={false}
              config={[
                {
                  headerName: "Sequence",
                  field: "rlkSeq",
                },
                {
                  headerName: "Location",
                  field: "locationName",
                  cellRenderer: ResizableScrollingTextRenderer,
                },
                 {
                  headerName: "Pick Drop Type",
                  field: "rlkPickDropValue",
                  cellRenderer: ResizableScrollingTextRenderer,
                },
                {
                  headerName: "Location Contact Name",
                  field: "rlkLocationContactName",
                  cellEditor: "agTextCellEditor",
                  editable: true,
                  tooltipValueGetter: (params) => {
                    return "press Enter to set the value";
                  },
                  cellRenderer: ResizableScrollingTextRenderer,
                },
                {
                  headerName: "Location Contact Number",
                  field: "rlkLocationContactNumber",
                  cellEditor: "agTextCellEditor",
                  editable: true,
                  tooltipValueGetter: (params) => {
                    return "press Enter to set the value";
                  },
                  cellRenderer: ResizableScrollingTextRenderer,
                },
                {
                  field: "Delete",
                  filter: true,
                  cellRenderer: ButtonRenderer,
                  cellRendererParams: (params) => ({
                    consider: AUTH_TYPES.DELETE,
                    clickHandler: () => {
                      setGridData((prevState) =>
                        prevState.filter((item) => item.id !== params.data.id)
                      );

                      //   setSeq((prevState) => --prevState);
                    },
                    label: "Delete",
                    disabled:
                      viewOnlyMode ||
                      (editMode && params.data?.rlkLocationTimeUpdated),
                    className: "ui red button",
                    // authenticated: true,
                    // form: `${FORM}`,
                    // module: MODULES.Transaction,
                    editMode:
                      params.data.rlkId !== null && isNumber(params.data.rlkId),
                  }),
                },
              ]}
              content={gridData}
            />

            <div
              className="three fields"
              style={{
                marginTop: "10px",
                display: "flex",
                alignItems: "flex-end",
                justifyContent: "flex-end",
                marginBottom: "10px",
              }}
            >
              <Dropdown
                label="Interval Type"
                clearable={false}
                options={intervalTypeOptions}
                value={intervalType}
                onChange={(e, data) => setIntervalType(data.value)}
              />

              {intervalType === 2 ? (
                <Input
                  label="Enter Interval in Minutes"
                  required={true}
                  type="number"
                  placeholder={`MAX Interval: ${maxIntervalInHoursAndMinutes}`}
                  value={selectedCustomInterval}
                  onChange={(e) => {
                    const value = e.target.value;
                    const valueMs = value * 60 * 1000;
                    if (valueMs <= maxIntervalInMs && valueMs > 0) {
                      setSelectedCustomInterval(value);
                      setCustomIntervalErrors({});
                    } else {
                      setCustomIntervalErrors({
                        interval: `MAX Interval: ${maxIntervalInHoursAndMinutes}`,
                      });
                      setSelectedCustomInterval("");
                    }
                  }}
                  error={customIntervalErrors.interval}
                  resetError={() =>
                    setCustomIntervalErrors((prevState) => {
                      const { interval: _, ...rest } = prevState;
                      return rest;
                    })
                  }
                />
              ) : (
                ""
              )}

              {allowBulkAddViaLocations && (
                <Button
                  disabled={
                    viewOnlyMode ||
                    !requestStartLocation?.rlkArrivalEta ||
                    !requestStartLocation?.rlkDepartureEta ||
                    !requestEndLocation?.rlkArrivalEta ||
                    !requestEndLocation?.rlkDepartureEta ||
                    gridData.length === 0 ||
                    (intervalType === 2 && selectedCustomInterval === "") ||
                    editMode
                  }
                  label={"Save"}
                  Icon={Save}
                  onClick={() => {
                    if (intervalType === 1) {
                      onAutoSchedule();
                    } else if (intervalType === 2) {
                      if (
                        selectedCustomInterval === "" ||
                        isNaN(selectedCustomInterval)
                      ) {
                        setCustomIntervalErrors({
                          interval: `Enter Interval in Minutes. MAX: ${maxIntervalInHoursAndMinutes}`,
                        });
                      } else {
                        setCustomIntervalErrors({});
                        onCustomSchedule();
                      }
                    }
                  }}
                  isLoading={isAddLoading}
                  style={{ height: "40px", marginTop: "24px" }}
                />
              )}
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default AddViaLocations;
